import { createFileRoute } from "@tanstack/react-router";
import { ConceptLanding } from "@/components/site/ConceptLanding";
export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Företagsevent, mässor & färdiga koncept | Event Sverige" },
      {
        name: "description",
        content:
          "Skapa en plats att mötas på med företagsmingel, lagkamp, arkadfest och mässaktivering. Vi planerar, riggar och leder aktiviteterna. Stämningsljus ingår.",
      },
      { property: "og:title", content: "Event Sverige – en plats att mötas på" },
      {
        property: "og:description",
        content:
          "Koncept för företagsevent och mässor, på dagen eller kvällen. Stämningsljus ingår.",
      },
    ],
    links: [{ rel: "canonical", href: "https://eventsverige.se/" }],
  }),
  component: () => <ConceptLanding />,
});
